var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badge",
    style: ({
      backgroundColor: _vm.colorCode,
      boxShadow: ("0 4px 10px " + _vm.colorCode + "33"),
      width: _vm.width || 'auto',
    })
  }, [(_vm.resolvedIcon) ? _c('div', {
    staticClass: "badge-icon-container"
  }, [_c('img', {
    staticClass: "badge-icon",
    attrs: {
      "src": _vm.resolvedIcon,
      "alt": "icon"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "badge-text"
  }, [_vm._v(_vm._s(_vm.shipment))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2158d837","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShipmentBadge.vue
// module id = 1510
// module chunks = 1